<template>
  <div v-if="timer_trigger_events && optionsSheet">
    <h3>{{optionsSheet.options.timer_trigger_events.title}}</h3>
    <div v-if="timer_trigger_events.length > 0">
      <div role="tablist">
        <div v-for="(timerEvent, index) in timer_trigger_events" :key="index">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle="accordionUuid + '-' + index" variant="info">Tick #{{index + 1}}</b-button>
            </b-card-header>
            <b-collapse :id="accordionUuid + '-' + index" visible :accordion="accordionUuid" role="tabpanel">
              <b-card-body>
                <PageEditorPropertiesEvents :events="timerEvent.events" :properties="optionsSheet.options.events" :eventTemplate="optionsSheet.options.eventTemplate" :components="components" :dataObject="dataObject" @onChange="addEvents(...arguments, timerEvent)"></PageEditorPropertiesEvents>
              </b-card-body>
              <b-button variant="danger" @click="removeEvent(timerEvent)"><font-awesome-icon icon="trash" /> - Remove Tick Event</b-button>
            </b-collapse>
          </b-card>
          <h4></h4>
          <hr/>
        </div>
      </div>
    </div>
    <div>

      <b-button @click="newEvent"><font-awesome-icon icon="plus" /> New Tick Group</b-button>
    </div>
  </div>
</template>

<script>
import uuidv4 from 'uuid/v4';
import _ from 'lodash';
import EditorEvents from '../../mixins/editor-events';
import PageEditorPropertiesEvents from './page-editor-properties-events.vue';
import PropertyOptions from '../../mixins/property-options';
import { usePageEditorStore } from '@/stores/PageEditorStore';

export default {
  name: 'PageEditorPropertiesTimerEvents',
  mixins: [EditorEvents, PropertyOptions],
  components: {
    PageEditorPropertiesEvents,
  },
  props: {
    timer_trigger_events: Array,
    components: Array,
    dataObject: Object,
  },
  setup() {
    const pageEditorStore = usePageEditorStore();
    return {
      pageEditorStore,
    };
  },
  data() {
    return {
      properties: {},
      optionsSheet: {},
      accordionUuid: uuidv4(),
    };
  },
  watch: {
    dataObject() {
      this.load();
    },
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.properties = this.dataObject.properties;
      this.optionsSheet = this.loadPropertyOptions(this.dataObject);
    },
    /**
     * Add an event to the timer_trigger_events
     */
    newEvent() {
      const event = {};
      event.id = uuidv4();
      event.events = [];
      this.timer_trigger_events.push(event);
      this.updateProperties();
    },
    /**
     * Remove the event
     * @param event
     */
    removeEvent(event) {
      for (let i = 0; i < this.timer_trigger_events.length; i += 1) {
        const storedEvent = this.timer_trigger_events[i];
        if (storedEvent.id === event.id) {
          this.timer_trigger_events.splice(i, 1);
        }
      }
      this.updateProperties();
    },
    addEvents(tickEvents, timerEvent) {
      if (tickEvents) {
        for (let i = 0; i < this.timer_trigger_events.length; i += 1) {
          const storedEvent = this.timer_trigger_events[i];
          if (storedEvent && storedEvent.id === timerEvent.id) {
            this.timer_trigger_events[i].events = _.cloneDeep(tickEvents);
            this.updateProperties();
          }
        }
      }
    },
    updateProperties() {
      this.$emit('onChange', this.timer_trigger_events);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
